module.exports = __webpack_public_path__ + "static/media/icicles.8aa49e7c.svg";